import {useQuery} from "@tanstack/react-query";
import { users } from '../../api';

export const useGetUsers = () => {
    return useQuery(["users"], users.get);
}
